export const REQUIRED_SERVICE_ACC_KEY_FIELDS = [ 'private_key', 'client_email' ];
